import React from 'react';

import { SubtractFill, AddFill } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';

import {
  CounterButton,
  CounterButtonLabel,
  StyledCounter,
  TooltipStyle,
  TourIncrementButtonWrapper,
} from './CounterStyle';
import { CounterProps } from './CounterInterface';

const Counter = ({
  count = 0,
  min = 0,
  max = 0,
  handleIncrement = () => false,
  handleDecrement = () => false,
  disabledDecrement = false,
  disabledIncrement = false,
  tooltipMessage = '',
  className,
  children,
}: CounterProps) => {
  return (
    <StyledCounter className={className}>
      <CounterButton
        data-testid='decrement-button'
        disabled={disabledDecrement || count <= min}
        onClick={handleDecrement}
      >
        <CustomIcon icon={SubtractFill} fontSize={16} paletteColor='white' />
      </CounterButton>
      <CounterButtonLabel data-testid='count-label'>
        {children || count}
      </CounterButtonLabel>
      <TooltipStyle
        placement='top'
        trigger='click'
        title={disabledIncrement ? tooltipMessage : ''}
        getPopupContainer={(triggerNode) => triggerNode}
      >
        <TourIncrementButtonWrapper>
          <CounterButton
            data-testid='increment-button'
            disabled={disabledIncrement || (max ? count >= max : false)}
            onClick={handleIncrement}
          >
            <CustomIcon icon={AddFill} fontSize={16} paletteColor='white' />
          </CounterButton>
        </TourIncrementButtonWrapper>
      </TooltipStyle>
    </StyledCounter>
  );
};

export default Counter;
